export function handleResponse(response) {
  const data = response.data;

  return data;
}
